import React, { useState } from 'react';
import propTypes from 'prop-types';
import Text from '../../typography'
import { Grid, Box } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from '../../../themes/default-theme';
import ReactHtmlParser from 'react-html-parser';
import { Cta, RespImg } from '../../ui';
import { makeStyles } from '@mui/styles';
import Modal from '../../ui/Modal';
import SpecsTableMotorised from '../SpecsTableMotorised';


const PreTableContent = styled.div`
  margin-bottom: 25px;
`

const Container = styled.div`  
  ${theme.breakpoints.down("sm")} {
        overflow-x: scroll;
        &::-webkit-scrollbar {
            height: 12px;
            border-radius: 20px;
            background-color: #F9F9F9;
   
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 20px;
          background: rgba(35,35,35,0.5);
        }
        ${props => props.margin == 1 && `
            padding-bottom: 40px;  
        `
  }
`

const TitleContainer = styled.div`
  ${theme.breakpoints.up("md")} {
    h3 {
      font-size: 34px;
    }
  }
`

const TextHandle = styled(props => {
  return <Text {...props} />
})`
  max-width: 815px;
  margin-left: auto;
  margin-right: auto;
`
const TextContent = styled.div`
  text-align: center;
  max-width: 800px;
  ${theme.breakpoints.up("md")} {
    margin: 43px auto 25px;
  }
  ${theme.breakpoints.down("sm")} {
      margin: 24px auto 24px;
  }
`
const TableContainer = styled.div`
  
`

const TableContainerCols = styled.div`
  display: flex;
`

const TableContainerCol = styled.div`
  ${props => props.widthNormal ? `
    width: calc(100%/${props.widthNormal});
    `: `
    width: 100%;
  `}

  &:not(:last-child) {
    border-right: 1px solid #D6D6D6;
  }
  ${theme.breakpoints.down("sm")} {
    min-width: 250px;
    width: 250px;
    &:nth-child(1) {
      min-width: 120px;
      width: 120px;
    }
  }
  ${"@media (max-width: 499px)"} {
    // min-width: 150px;
    // width: 150px;
    // &:nth-child(1) {
    //   min-width: 94px;
    //   width: 94px;
    // }
  }
`
const TableContainerColImg = styled.div`
  display: flex;
  flex-direction: column;
  gap: 19px;
  p {
    margin-bottom: 0;
    &:nth-child(1) {
      margin-top: 0;
    }
  }
  ${theme.breakpoints.up("md")} {
    padding: 24px 15px 20px;
    > h4 {
      font-size: 14px;
    }
    > div {
      font-size: 15px;
    }
    picture, ing {
      max-width: 173px;
      margin: auto;
    }
  }
  ${theme.breakpoints.down("sm")} {
    padding: 24px 10px 10px;
    > h4 {
      font-size: 13px;
      min-height: 32px;
    }
    > div {
      font-size: 12px;
    }
    picture, ing {
      max-width: 130px;
      margin: auto;
    }
  }
`

const TableContainerColContent = styled.div`
${theme.breakpoints.up("md")} {
  > div {
    > div {
      display: flex;
      &:nth-child(odd) {
        background: #F9F9F9;
      }
      > div {
        font-size: 15px;
        padding: 18px 16px;
        line-height: normal;
      }
    }
  }
  ${props => props.widthSpecs && `
      > div > div > div {
      width: calc(100%/${props.widthSpecs});
      &:not(:last-child) {
        border-right: 1px solid #D6D6D6;
      }
      }
  `}
}
${theme.breakpoints.down("sm")} {
  > div {
    > div {
      display: flex;
      > div {
        font-size: 12px;
        padding: 18px 9px;
        line-height: normal;
      }
    }
  }
  ${props => props.widthSpecs && `
      > div > div {
        width: 100vw;
        &:nth-child(odd) {
          > div {
            background: #F9F9F9;
          }
        }
        > div {
          min-width: 250px;
          width: 250px;
          &:nth-child(1) {
            min-width: 120px;
            width: 120px;
          }
          &:not(:last-child) {
            border-right: 1px solid #D6D6D6;
          }
        }
      }
      ${props => (props.background == 'black' || props.background == 'dark') && `
        > div > div {
          &:nth-child(odd) {
            > div {
              background: black;
            }
          }
        }
      `}
  `}
}
${"@media (max-width: 499px)"} {
  ${props => props.widthSpecs && `
      > div > div {
        > div {
          // min-width: 150px;
          // width: 150px;
          // &:nth-child(1) {
          //   min-width: 94px;
          //   width: 94px;
          // }
        }
      }
  `}
}
${props => props.align == 'left' && `
  > div {
    justify-content: left!important;
  }
`}
  ${props => (props.background == 'black' || props.background == 'dark') && `
    > div > div {
      border-bottom: 1px solid #F9F9F9;
      &:nth-child(odd) {
        > div {
          background: black;
        }
      }
      &:nth-of-type(1) {
        border-top: 1px solid #F9F9F9;
      }
    }
`}

`

const CtaContainer = styled.div`
  margin-top: 19px;
  button {
    padding: 13px 3px;
  }
  ${theme.breakpoints.up("md")} {
      padding: 0 16px;
    
  }
  ${theme.breakpoints.down("sm")} {
      padding: 0 9px;
  }
`

const useStyles = makeStyles(() => ({
  modalInner: {
    maxWidth: 1220,
    margin: '0 auto',
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: 1320,
      paddingLeft: 50,
      paddingRight: 50
    }
  },
  modalClose: {
      top: '5px',
      right: '5px',
      left: 'auto',
      transform: 'none',
      position: 'absolute',
      
      '& button': {
          background: '#0170D4'
      }
  }
}))

const motorisedTableComparisonDefaultPropModels = [];

const MotorisedTableComparison = ({
  title = "",
  preTitle = "",
  text = "",
  models = motorisedTableComparisonDefaultPropModels,
  colourTheme,
  modal = null,
  rangeId,
  seriesId,
  uri = null
}) => {

  const [activeModel, setActiveModel] = useState('');

  const [openModal, setOpenModal] = useState(false);
    
  const handleLaunchModal = (e, title) => {
      if (e) {
          e.preventDefault();
      }
      console.log('launch modal', e);
      setOpenModal(true);
      setActiveModel(title);
  }

  const classes = useStyles();

  const tableComparisonTitles = models?.length > 0 && models.map((item) => {
    return (
      item.specs?.length > 0 && item.specs.map((child) => {
        return (
          child.title
        );
      })

    )
  }).flat(1);
  const list = new Set();
  const rmvDuplicTableComparTitles = tableComparisonTitles?.length > 0 && tableComparisonTitles.filter(item => {
    const duplicate = list.has(item);
    list.add(item);
    return !duplicate;
  });

  const matchedValues = rmvDuplicTableComparTitles.map((item, index) => {
    return (models.map((parent) => parent.specs.filter((child) => child.title.toLowerCase() == item.toLowerCase())[0]))
  });
  console.log('colourTheme', colourTheme)
  return (
    <>
      { (preTitle || title || text) &&
        <PreTableContent>
          <Grid container spacing={0} direction={'row'}>
            <Grid size={12}>
              <Box px={2}>
                {(preTitle || title) &&
                  <TitleContainer>
                    <Box px={2}>
                      {preTitle &&
                        <TextHandle variant="subTitle" colour={'vividBlue'} align="center">{preTitle}</TextHandle>
                      }
                      {title &&
                        <TextHandle element="h3" variant="h2" uppercase colour={colourTheme && (colourTheme == 'black' || colourTheme == 'dark')  ?  'white' : 'charcoal'} weight={800} align="center">{ReactHtmlParser(title)}</TextHandle>
                      }
                    </Box>
                  </TitleContainer>
                }
                {text &&
                  <TextContent>
                    <Text variant="body1" colour={colourTheme && (colourTheme == 'black' || colourTheme == 'dark')  ?  'white' : 'charcoal'} alignItems={'flex-start'}>{ReactHtmlParser(text)}</Text>
                  </TextContent>
                }
                </Box>
            </Grid>
          </Grid>
        </PreTableContent>
      }
      <Container margin={1}>
          {(openModal) && 
            <Modal
                isOpen={openModal}
                onClose={() => setOpenModal(false)}
                // overlayClassname={classes.modalOverlay}
                innerClassname={classes.modalInner}
                closeClassname={classes.modalClose}
            >   
                    <SpecsTableMotorised
                        {...modal}
                        background={colourTheme ==='dark' ? 'black' : 'white'}
                        selectedModel={activeModel?.toLowerCase()}
                        rangeId={rangeId}
                        seriesId={seriesId}
                        uri={uri && uri}
                    />

            </Modal>
        }
        <Grid container spacing={0} direction={'row'}>
          <Grid size={12}>
            <Box px={2}>
              {models && models.length > 0 &&
                <TableContainer>
                  <TableContainerCols>
                    <TableContainerCol widthNormal={models.length + 1}>
                      {models[0].image &&
                        <TableContainerColImg>

                        </TableContainerColImg>
                      }
                    </TableContainerCol>
                    {
                      models.map((item, index) => {
                        return (
                          <TableContainerCol key={index} widthNormal={models.length + 1}>
                            <TableContainerColImg>
                              <RespImg
                                {...item.image}
                                lazyLoad={false}
                                type={'png'}
                              />
                              {item.title &&
                                <Text variant="h4" colour={colourTheme && (colourTheme == 'black' || colourTheme == 'dark')  ?  'white' : 'charcoal'} align="center" uppercase weight={700}>{item.title}</Text>
                              }
                              {item.text &&
                                <Text variant="body2" align="center" colour={colourTheme && (colourTheme == 'black' || colourTheme == 'dark')  ?  'white' : 'charcoal'}>{ReactHtmlParser(item.text)}</Text>
                              }
                            </TableContainerColImg>
                          </TableContainerCol>
                        );
                      })
                    }
                  </TableContainerCols>
                </TableContainer>

              }
              {models && models.length > 0 &&
                <TableContainer>
                  <TableContainerCols>
                    <>
                      <TableContainerCol>
                        {matchedValues && matchedValues.length > 0 &&
                          <TableContainerColContent align="left" widthSpecs={models.length + 1} background={colourTheme && colourTheme}>
                            {matchedValues.length > 0 &&
                              <div>
                                {matchedValues.map((item, index) => {
                                  return (
                                    <div key={index}>

                                      {rmvDuplicTableComparTitles[index] &&
                                        <Text key={index} variant="body2" align={'left'} colour={colourTheme && (colourTheme == 'black' || colourTheme == 'dark')  ?  'white' : 'charcoal'} weight={400}>{rmvDuplicTableComparTitles[index]}</Text>

                                      }
                                      {matchedValues && matchedValues.length > 0 &&
                                        models.map((child, i) => {
                                          return (

                                            
                                              item[i]?.value ?
                                                <Text key={i} variant="body2" align="center" colour={colourTheme && (colourTheme == 'black' || colourTheme == 'dark')  ?  'white' : 'charcoal'} weight={400}>{item[i].value}</Text>
                                                :
                                                <Text key={i} variant="body2" align="center" colour={colourTheme && (colourTheme == 'black' || colourTheme == 'dark')  ?  'white' : 'charcoal'} weight={400}>-</Text>
                                              
                                            

                                          );
                                        })

                                      }
                                    </div>
                                  )
                                })}
                              </div>
                            }




                          </TableContainerColContent>
                        }
                      </TableContainerCol>

                    </>
                  </TableContainerCols>

                  {models && models.length > 0 &&
                    <TableContainer>
                      <TableContainerCols>
                        <TableContainerCol widthNormal={models.length + 1}>
                        </TableContainerCol>
                        {models.map((item, index) => {
                          return (

                            (item.cta && item.cta.title) &&
                            <TableContainerCol key={index} widthNormal={models.length + 1}>
                              <CtaContainer>
                                <Cta outline onClick={(e) => handleLaunchModal(e, item.title)}>
                                  {item.cta.title}
                                </Cta>
                              </CtaContainer>
                            </TableContainerCol>

                          )
                        })}

                      </TableContainerCols>
                    </TableContainer>
                  }
                </TableContainer>

              }
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

MotorisedTableComparison.propTypes = {
  title: propTypes.string,
  preTitle: propTypes.string,
  text: propTypes.string,
  models: propTypes.array,
  modal: propTypes.object,
  uri: propTypes.string
}

export default MotorisedTableComparison